import { mapActions, mapGetters, mapState } from "vuex";
import i18n from '@/i18n'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";
import navbarService from "../../../services/navbar.service";

export default {
    name: "NavbarComponent",
    props: {},
    components: {
        AutocompleteComponent,
    },
    data() {
        return {
            search: null,
            navBarButtons: [
                {
                    title: 'navbar.user',
                    route: '/app/user',
                    subMenu: [
                        {
                            title: 'navbar.profiles',
                            icon: 'dashboard',
                            route: { path: '/app/user-profiles' }
                        }
                    ],
                },
                {
                    title: 'navbar.gps',
                    route: 'app/gps',
                    subMenu: [
                        {
                            title: 'navbar.gpsABM',
                            icon: 'dashboard',
                            route: { path: '/app/gps-abm' }
                        }
                    ],
                },
                {
                    title: 'navbar.equipment',
                    route: 'app/equipment',
                    subMenu: [
                        {
                            title: 'navbar.equipmentABM',
                            icon: 'dashboard',
                            route: { path: '/app/equipment-abm' }
                        }
                    ],
                },
                {
                    title: 'navbar.line',
                    route: 'app/line',
                    subMenu: [
                        {
                            title: 'navbar.lineABM',
                            icon: 'dashboard',
                            route: { path: '/app/line-abm' }
                        }
                    ],
                }
            ],
            abmSelectorItems: [
                {
                    key: 'EQUIPMENT',
                    name: i18n.t('equipment.name'),
                    routeName: 'equipmentABM'
                },
                {
                    key: 'MODULO',
                    name: i18n.t('gps.name'),
                    routeName: 'GpsABM'
                },
                {
                    key: 'LINE',
                    name: i18n.t('line.name'),
                    routeName: 'LinesABM'
                },
                {
                    key: 'USER_PROFILES',
                    name: i18n.t('userProfiles.name'),
                    routeName: 'profileABM'
                },
                {
                    key: 'USER',
                    name: i18n.t('user.name'),
                    routeName: 'UserABM'
                },
                {
                    key: 'ENTERPRISE',
                    name: i18n.t('enterprise.name'),
                    routeName: 'EnterpriseABM'
                },
                {
                    key: 'GROUP',
                    name: i18n.t('group.name'),
                    routeName: 'GroupABM'
                },
                {
                    key: 'FLEET',
                    name: i18n.t('fleet.name'),
                    routeName: 'FleetABM'
                },
                {
                    key: 'WORK_FRONT',
                    name: i18n.t('workFront.name'),
                    routeName: 'WorkFrontABM'
                },
                {
                    key: 'FARM',
                    name: i18n.t('farm.name'),
                    routeName: 'FarmABM'
                },
                {
                    key: 'ECOLOGICAL_UNIT',
                    name: i18n.t('ecologicalUnit.name'),
                    routeName: 'EcologicalUnitABM'
                },
                {
                    key: 'ZONE',
                    name: i18n.t('zone.name'),
                    routeName: 'ZoneABM'
                },
                {
                    key: 'PERSON',
                    name: i18n.t('person.name'),
                    routeName: 'PersonABM'
                },
                {
                    key: 'SENT_COMMANDS',
                    name: i18n.t('sentCommandsReport.name'),
                    routeName: 'SentCommandsReport'
                },
                {
                    key: 'COMMANDS_MASSIVE_UPLOAD',
                    name: i18n.t('commandMassiveUpload.name'),
                    routeName: 'CommandMassiveUpload'
                },
                {
                    key: 'DISCARDED_INFRACTIONS',
                    name: i18n.t('scoring.discardedInfractionsReport.name'),
                    routeName: 'DiscardedInfractionsReport'
                },
                {
                    key: 'EVENT_TYPE',
                    name: i18n.t('eventType.name'),
                    routeName: 'EventTypeABM'
                },
                {
                    key: 'STATE_TYPE',
                    name: i18n.t('stateType.name'),
                    routeName: 'StateTypeABM'
                },
                {
                    key: 'CATEGORY',
                    name: i18n.t('category.name'),
                    routeName: 'CategoryABM'
                },
                {
                    key: 'ALERT_EVENT',
                    name: i18n.t('alertEvent.name'),
                    routeName: 'AlertEventABM'
                },
                {
                    key: 'GOALS',
                    name: i18n.t('goals.name'),
                    routeName: 'GoalsABM'
                },
                {
                    key: 'NOTIFICATION_STATUS',
                    name: i18n.t('notificationStatus.name'),
                    routeName: 'NotificationStatus'
                },
                {
                    key: 'CURRENT_STATE',
                    name: i18n.t('currentState.name'),
                    routeName: 'CurrentStateComponent'
                }
            ]
        };
    },
    beforeMount() {
        navbarService.setNavigationListByPrivileges(this.abmSelectorItems);
    },
    mounted() {
    },
    updated() {
    },
    computed: {
        ...mapGetters('user', [
            'getUsername',
            'getLogo'
        ]),
        ...mapState('user', {
            userName: state => state.userName
        }),
        logoSource() {
            if (this.getLogo) {
                return 'data:image/png;base64,' + this.getLogo;
            } else {
                return require('../../../assets/logo.png')
            }
        }
    },
    created() {
    },
    beforeDestroy() {
    },
    methods: {
        ...mapActions('user', {
            clearSessionData: 'clearSessionData',
        }),
        ...mapActions('reportBug', {
            openReportBugDialog: 'openReportBugDialog',            
            openSecondFactorDialog: 'secondFactor/openSecondFactorDialog',
            setFieldsRequired: 'setFieldsRequired'
        }),
        ...mapActions({         
            openSecondFactorDialog: 'secondFactor/openSecondFactorDialog'
        }),
        logout() {
            this.clearSessionData()
            this.$router.push('/login');
        },
        name() {
            return this.getUsername
        },
        /**
         * Dialog para reportar errores
         */
        reportBug() {
            this.setFieldsRequired(true)
            this.openReportBugDialog()
        },
        /**
        * Dialog para modificar la configuracion de 2do factor de autentificacion
        */
        secondFactor () {      
         this.openSecondFactorDialog()
       },
        abmSelected(val) {
            this.$router.push({ name: val.routeName })
        }
    },
    watch: {
    },
};
